export default "__VITE_ASSET__45vF6rWa__"